import type { LanguageProficiency as LanguageType } from '@seek/ca-myprofile-utils';
import { ProfileItemContent } from '@seek/profile-read-ui';

export interface LanguageProps extends LanguageType {
  editLanguage?: (id: string) => void;
}

export const Language = ({ id, name, editLanguage }: LanguageProps) => (
  <ProfileItemContent
    type="language"
    id={id}
    title={name.text}
    isValid={true}
    confirmed={true}
    editFn={editLanguage}
  />
);
